import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

// import required modules
import { Autoplay, Pagination } from "swiper";
import {
  styled,
  Menu,
  AppBar,
  Toolbar,
  Typography,
  Box,
  Tooltip,
  Button,
  ListItemText,
  ListItemIcon,
  ListItem,
  List,
  MenuItem,
  ListItemButton,
  duration,
} from "@mui/material";
import { motion } from "framer-motion";
import React from "react";
import { StyledIconButton } from "../Footer";
import {
  TfiDribbble,
  TfiFacebook,
  TfiInstagram,
  TfiPinterest,
  TfiTwitter,
  TfiYoutube,
} from "react-icons/tfi";
import Zoom from "@mui/material/Zoom";
import { useState } from "react";
import { MdExpandMore } from "react-icons/md";
import {
  bindMenu,
  bindHover,
  usePopupState,
} from "material-ui-popup-state/hooks";
import HoverMenu from "material-ui-popup-state/HoverMenu";
import { ReactComponent as EUR } from "../../assets/images/currency/eur.svg";
import { ReactComponent as GBP } from "../../assets/images/currency/gbp.svg";
import { ReactComponent as HKD } from "../../assets/images/currency/hkd.svg";
import { ReactComponent as JPY } from "../../assets/images/currency/jpy.svg";
import { ReactComponent as USD } from "../../assets/images/currency/usd.svg";

const TopAppBar = styled((props) => (
  <AppBar position="static" {...props}>
    {props.children}
  </AppBar>
))(({ theme }) => ({
  "&.MuiAppBar-root": {
    minHeight: "50px",
    height: "50px",
    background: "#3E3E3E",
    "& .MuiToolbar-root": {
      minHeight: "100%",
      height: "100%",
      "& .socialMedia": {
        "& .MuiButtonBase-root": {
          background: "#3E3E3E",
          border: "1px solid",
          padding: "5px",
          "& svg": {
            fontSize: "14px",
          },
        },
      },
    },
  },
}));
const NavList = styled((props) => <List {...props}>{props.children}</List>)(
  ({ theme }) => ({
    display: "flex",
    gap: theme.spacing(1),
    "& .MuiButtonBase-root": {
      paddingLeft: "5px",
      paddingRight: "5px",

      "& .MuiListItemText-root": {
        "& .MuiTypography-root": {
          color: "white",
        },
      },
      "& .MuiListItemIcon-root": {
        color: "white",
        minWidth: "auto",
        marginLeft: "5px",
      },
    },
  })
);

const TopNavbar = () => {
  const [lang, setLang] = useState({ title: "English", code: "en" });
  const [currency, setCurrency] = useState({ icon: <USD />, code: "usd" });
  const TopNavbarStats = [
    "Fantastic theme! Beautifully designed!",
    "Summer Sale ",
    "Made With Love",
    "Customer support is second to one",
    "Summer sale discount is 50%! Shop Now",
    "The Best Shopify Themes.",
  ];
  const currencyArray = [
    { icon: <EUR />, code: "EUR" },
    { icon: <GBP />, code: "GBP" },
    { icon: <HKD />, code: "HKD" },
    { icon: <JPY />, code: "JPY" },
    { icon: <USD />, code: "USD" },
  ];
  const langPopUpState = usePopupState({
    variant: "popover",
    popupId: "langpopup",
  });
  const currencyPopUpState = usePopupState({
    variant: "popover",
    popupId: "currencypopup",
  });

  return (
    <TopAppBar>
      <Toolbar>
        <Box
          className="socialMedia"
          sx={{
            flex: "1 1 20%",
            alignItems: "center",
            gap: "5px",
            display: { xs: "none", lg: "flex" },
          }}
        >
          <Tooltip
            TransitionComponent={Zoom}
            TransitionProps={{ timeout: 300 }}
            title="Follow On Facebook"
            arrow
            placement="top"
          >
            <div style={{ display: "inline-block" }}>
              <StyledIconButton
                sx={{
                  "&:hover": {
                    transform: "translate(0,-5px)",
                    color: "#0071BD",
                  },
                }}
              >
                <TfiFacebook />
              </StyledIconButton>
            </div>
          </Tooltip>

          <Tooltip
            TransitionComponent={Zoom}
            TransitionProps={{ timeout: 300 }}
            title="Follow On Twitter"
            arrow
            placement="top"
          >
            <div style={{ display: "inline-block" }}>
              <StyledIconButton
                sx={{
                  "&:hover": {
                    transform: "translate(0,-5px)",
                    color: "aqua",
                  },
                }}
              >
                <TfiTwitter />
              </StyledIconButton>
            </div>
          </Tooltip>

          <Tooltip
            TransitionComponent={Zoom}
            TransitionProps={{ timeout: 300 }}
            title="Follow On Instagram"
            arrow
            placement="top"
          >
            <div style={{ display: "inline-block" }}>
              <StyledIconButton
                sx={{
                  "&:hover": {
                    transform: "translate(0,-5px)",
                    color: "#0071BD",
                  },
                }}
              >
                <TfiInstagram />
              </StyledIconButton>
            </div>
          </Tooltip>

          <Tooltip
            TransitionComponent={Zoom}
            TransitionProps={{ timeout: 300 }}
            title="Follow On Dribble"
            arrow
            placement="top"
          >
            <div style={{ display: "inline-block" }}>
              <StyledIconButton
                sx={{
                  "&:hover": {
                    transform: "translate(0,-5px)",
                    color: "blue",
                  },
                }}
              >
                <TfiDribbble />
              </StyledIconButton>
            </div>
          </Tooltip>

          <Tooltip
            TransitionComponent={Zoom}
            TransitionProps={{ timeout: 300 }}
            title="Follow On Pinterest"
            arrow
            placement="top"
          >
            <div style={{ display: "inline-block" }}>
              <StyledIconButton
                sx={{
                  "&:hover": {
                    transform: "translate(0,-5px)",
                    color: "red",
                  },
                }}
              >
                <TfiPinterest />
              </StyledIconButton>
            </div>
          </Tooltip>

          <Tooltip
            TransitionComponent={Zoom}
            TransitionProps={{ timeout: 300 }}
            title="Follow On Youtube"
            arrow
            placement="top"
          >
            <div style={{ display: "inline-block" }}>
              <StyledIconButton
                sx={{
                  "&:hover": {
                    transform: "translate(0,-5px)",
                    color: "red",
                  },
                }}
              >
                <TfiYoutube />
              </StyledIconButton>
            </div>
          </Tooltip>
        </Box>
        <Box
          as={motion.div}
          sx={{
            display: "flex",
            flex: "1 1 60%",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Swiper
            direction={"vertical"}
            modules={[Autoplay]}
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
            }}
            className="mySwiper"
            style={{ height: "50px", minHeight: "50px" }}
            loop={true}
          >
            {TopNavbarStats.map((item) => {
              return (
                <SwiperSlide
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                >
                  <Typography
                    sx={{
                      color: "white",
                      fontFamily: "Lato,sans-serif",
                      fontSize: "14px",
                      lineHeight: "25px",
                    }}
                  >
                    {item}
                  </Typography>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </Box>
        <Box
          sx={{
            flex: "1 1 20%",
            alignItems: "center",
            justifyContent: "end",
            gap: "5px",
            display: { xs: "none", lg: "flex" },
          }}
        >
          <NavList>
            <ListItemButton {...bindHover(langPopUpState)}>
              <ListItemText primary={lang.title} />
              <ListItemIcon>
                <MdExpandMore />
              </ListItemIcon>
            </ListItemButton>
            <ListItemButton {...bindHover(currencyPopUpState)}>
              <ListItemIcon
                sx={{
                  width: "25px",
                  height: "25x",
                  minWidth: "25px",
                  marginRight: "5px",
                }}
              >
                {currency.icon}
              </ListItemIcon>
              <ListItemText primary={currency.code} />
              <ListItemIcon>
                <MdExpandMore />
              </ListItemIcon>
            </ListItemButton>
          </NavList>
          <HoverMenu
            disableScrollLock={true}
            sx={{
              zIndex: 9999999,
              "& .MuiPaper-root": {
                background: (theme) => theme.palette.background.paper,
                padding: "0 4px",
                textAlign: "center",
              },
            }}
            {...bindMenu(langPopUpState)}
            //   getContentAnchorEl={null}
            anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
            transformOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
          >
            <MenuItem
              onClick={() => {
                setLang({ title: "English", code: "en" });
                langPopUpState.close();
              }}
            >
              English
            </MenuItem>
            <MenuItem
              onClick={() => {
                setLang({ title: "العربية", code: "ar" });
                langPopUpState.close();
              }}
            >
              العربية
            </MenuItem>
          </HoverMenu>

          <HoverMenu
            className="currencyMenu"
            disableScrollLock={true}
            sx={{
              zIndex: 9999999,
              "& .MuiPaper-root": {
                background: (theme) => theme.palette.background.paper,
                textAlign: "center",
              },
            }}
            {...bindMenu(currencyPopUpState)}
            anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
            transformOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
          >
            {currencyArray.map((item) => (
              <ListItemButton
                sx={{ paddingLeft: "10px", paddingRight: "10px" }}
                onClick={() => {
                  setCurrency({ icon: item.icon, code: item.code });
                  langPopUpState.close();
                }}
              >
                <ListItemIcon
                  sx={{
                    width: "25px",
                    height: "25x",
                    minWidth: "25px",
                    marginRight: "5px",
                  }}
                >
                  {item.icon}
                </ListItemIcon>
                <ListItemText primary={item.code} />
              </ListItemButton>
            ))}
          </HoverMenu>
        </Box>
      </Toolbar>
    </TopAppBar>
  );
};

export default TopNavbar;
